import { useState, useEffect, useMemo } from "react";
import { Form } from "reactstrap";
import { APILA } from "../../../../../../config/apila";
import { APIMS } from "../../../../../../config/apims";
import Modal from "react-bootstrap/Modal";
import { useMutation } from "react-query";
import "bulma/css/bulma.css";
import "../../../../../../index.css";
import ToastError from "../../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../../NotificationToast/ToastSuccess";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faTrash } from "@fortawesome/free-solid-svg-icons";


export default function ModalTambahEvent(props) {
  const token = localStorage.getItem("token");
  const isEdit = props?.mode === "edit";
  const initial = props?.initialData || null;

  const [isSubmitting, setIsSubmitting] = useState(false);

  // Loader per-select
  const [loadingTA, setLoadingTA] = useState(false);
  const [loadingCabang, setLoadingCabang] = useState(false);
  const [loadingSekolah, setLoadingSekolah] = useState(false);
  const [loadingEvent, setLoadingEvent] = useState(false);

  const [page] = useState(0);
  const [limit] = useState(100);
  const [ascending] = useState(0);
  const [keyword] = useState("");

  // Data select
  const [getDataCabang, setGetDataCabang] = useState([]);
  const [getDataTA, setGetDataTA] = useState([]);
  const [getDataSekolah, setGetSekolah] = useState([]);
  const [getDataEvent, setGetEvent] = useState([]);

  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }),
    [token]
  );

  const id_user = localStorage
    .getItem("id_admin")
    ?.replace(/[|&;$%@"<>()+,]/g, "");

  // helper aman ambil value
  const pick = (obj, keys, fallback = "") => {
    for (const k of keys) {
      const v = obj?.[k];
      if (v !== undefined && v !== null && v !== "") return v;
    }
    return fallback;
  };

  const [form, setForm] = useState({
    // filter/master
    ysb_semester_id: "",
    ysb_branch_id: "",
    ysb_school_id: "",
    ysb_grade_level_id: "",
    ysb_kelas_id: "",
    ysb_event_id: "", 
    title: "",
    description: "",
    date_in: "",
    date_out: "",
  });

  // ===== Reset ketika cabang berubah =====
  const resetAfterBranchChange = () => {
    setGetSekolah([]);
    setForm((prev) => ({
      ...prev,
      ysb_school_id: "",
    }));
  };

  // ===== Fetch TA =====
  const GetResponseTA = async () => {
    try {
      setLoadingTA(true);
      const response = await APILA.get(
        `/api/semesters?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}`,
        fetchParams
      );
      setGetDataTA(response.data.data || []);
    } catch (error) {
      setGetDataTA([]);
    } finally {
      setLoadingTA(false);
    }
  };

  // ===== Fetch Cabang  =====
  const GetResponseCabang = async () => {
    try {
      setLoadingCabang(true);
      const response = await APIMS.get(
        `/api/branches?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}`,
        fetchParams
      );
      setGetDataCabang(response.data.data || []);
    } catch (error) {
      setGetDataCabang([]);
    } finally {
      setLoadingCabang(false);
    }
  };

   // ===== Fetch Event  =====
  const GetResponseEvent = async () => {
    try {
      setLoadingEvent(true);
      const response = await APIMS.get(
        `/api/events?page=${page}&limit=${limit}&ascending=${ascending}`,
        fetchParams 
      );
      setGetEvent(response.data.data || []);
    } catch (error) {
      setGetEvent([]);
    } finally {
      setLoadingEvent(false);
    }
  };

  useEffect(() => {
    GetResponseTA();
    GetResponseCabang();
    GetResponseEvent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ===== Fetch Sekolah  =====
  const GetResponseSekolah = async () => {
    try {
      setLoadingSekolah(true);
      const response = await APIMS.get(
        `/api/schools?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}&ascending_name=true&branch=${form?.ysb_branch_id}`,
        fetchParams
      );
      setGetSekolah(response.data.data || []);
    } catch (error) {
      setGetSekolah([]);
    } finally {
      setLoadingSekolah(false);
    }
  };

  useEffect(() => {
    if (form?.ysb_branch_id) {
      GetResponseSekolah();
    } else {
      setGetSekolah([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form?.ysb_branch_id]);


 

  // ===== Prefill saat modal dibuka (ADD/EDIT) =====
  useEffect(() => {
    // mode EDIT
    if (isEdit && initial) {
      setForm((prev) => ({
        ...prev,
        ysb_semester_id: pick(initial, ["ysb_semester_id"]),
        ysb_branch_id: pick(initial, ["ysb_branch_id"]),
        ysb_school_id: pick(initial, ["ysb_school_id"]),
        ysb_grade_level_id: pick(initial, ["ysb_grade_level_id"], ""),
        ysb_kelas_id: pick(initial, ["ysb_kelas_id"], ""),
        ysb_event_id: pick(initial, ["ysb_event_id"], ""),
        title: pick(initial, ["title"], ""),
        description: pick(initial, ["description"], ""),
        date_in: String(pick(initial, ["date_in"], "")).slice(0, 10),
        date_out: String(pick(initial, ["date_out"], "")).slice(0, 10),
      }));
      return;
    }

    // mode ADD (klik tanggal)
    const d = props?.prefillDate ? String(props.prefillDate).slice(0, 10) : "";

    setForm((prev) => ({
      ...prev,
      // ikutkan filter dari halaman (kalau ada)
      ysb_semester_id: props?.filterContext?.ysb_semester_id || prev.ysb_semester_id,
      ysb_branch_id: props?.filterContext?.ysb_branch_id || prev.ysb_branch_id,
      ysb_school_id: props?.filterContext?.ysb_school_id || prev.ysb_school_id,
      ysb_grade_level_id: props?.filterContext?.ysb_grade_level_id || prev.ysb_grade_level_id,

      date_in: d || prev.date_in,
      date_out: d || prev.date_out,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.show]);

  // ===== handleChange =====
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "ysb_branch_id") {
      resetAfterBranchChange();
      setForm((prev) => ({ ...prev, ysb_branch_id: value }));
      return;
    }

    setForm((prev) => ({ ...prev, [name]: value }));
  };

  // ===== Submit (POST/PUT ke APIMS) =====
  const handleSubmit = useMutation(async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      if (!form.ysb_semester_id) throw new Error("Tahun Ajaran wajib dipilih");
      if (!form.ysb_branch_id) throw new Error("Cabang wajib dipilih");
      if (!form.ysb_school_id) throw new Error("Sekolah wajib dipilih");
      if (!form.title?.trim()) throw new Error("Judul wajib diisi");
      if (!form.date_in) throw new Error("Tanggal Mulai wajib diisi");
      if (!form.date_out) throw new Error("Tanggal Akhir wajib diisi");

      const payload = {
        ysb_semester_id: form.ysb_semester_id,
        ysb_branch_id: form.ysb_branch_id,
        ysb_school_id: form.ysb_school_id,
        ysb_grade_level_id: form.ysb_grade_level_id || "",
        ysb_kelas_id: form.ysb_kelas_id || "",
        ysb_event_id: form.ysb_event_id || "",
        title: form.title,
        description: form.description || "",
        date_in: form.date_in,
        date_out: form.date_out,
        user_id: id_user,
      };

      if (isEdit) {
        const id = initial?.id;
        if (!id) throw new Error("ID event tidak ditemukan");

        const res = await APIMS.put(props.apiUpdate(id), payload, fetchParams);

        ToastSuccess.fire({
          icon: "success",
          title: res.data?.message || "Event berhasil diperbarui",
        });
      } else {
        const res = await APIMS.post(props.apiCreate, payload, fetchParams);

        ToastSuccess.fire({
          icon: "success",
          title: res.data?.message || "Event berhasil ditambahkan",
        });
      }

      props.GetResponseData?.();
      props.onHide?.();
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title: error.response?.data?.message || error.message || "Gagal menyimpan data",
      });
    } finally {
      setIsSubmitting(false);
    }
  });

  const handleDelete = () => {
    const id = initial?.id;
    if (!id) return;
    props.onDeleted?.(id);
    props.onHide?.();
  };

  return (
    <div className="modal module-page">
      <Modal
        {...props}
        size="lg"
        dialogClassName="module-modal-dialog module-modal-dialog-lg"
        contentClassName="module-modal-content"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={false}
      >
        <div className="module-modal-header">
          <div>
            <h5 className="module-modal-title">
              {isEdit ? "Edit Jadwal Acara" : "Tambah Jadwal Acara"}
            </h5>
            
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
            {isEdit && (
              <button
                type="button"
                className="module-modal-close"
                title="Hapus jadwal acara"
                aria-label="Hapus jadwal acara"
                onClick={handleDelete}
                style={{ color: "#e14f61" }}
              >
                <FontAwesomeIcon icon={faTrash} />
              </button>
            )}

            <button
              type="button"
              className="module-modal-close"
              aria-label="Tutup modal"
              onClick={() => props.onHide?.()}
            >
              <FontAwesomeIcon icon={faXmark} />
            </button>
          </div>
        </div>

        <Form onSubmit={(e) => handleSubmit.mutate(e)}>
          <Modal.Body className="module-modal-body mt-1 mx-2">
            <div className="module-form-grid">
              <div className="module-form-group">
                <label className="module-form-label" htmlFor="calendar-semester">
                  Tahun Ajaran <span>*</span>
                </label>
                <select
                  id="calendar-semester"
                  name="ysb_semester_id"
                  onChange={handleChange}
                  value={form.ysb_semester_id}
                  className="module-form-select"
                  disabled={loadingTA}
                >
                  <option value="" disabled>
                    {loadingTA ? "Memuat data..." : "Pilih Tahun Ajaran"}
                  </option>
                  {getDataTA.map((ta) => (
                    <option key={ta?.id} value={ta?.id}>
                      {ta?.name_year} (Semester {ta?.semester})
                    </option>
                  ))}
                </select>
              </div>

              <div className="module-form-group">
                <label className="module-form-label" htmlFor="calendar-branch">
                  Cabang <span>*</span>
                </label>
                <select
                  id="calendar-branch"
                  name="ysb_branch_id"
                  onChange={handleChange}
                  value={form.ysb_branch_id}
                  className="module-form-select"
                  disabled={loadingCabang}
                >
                  <option value="" disabled>
                    {loadingCabang ? "Memuat data..." : "Pilih Cabang"}
                  </option>
                  {getDataCabang.map((cabang) => (
                    <option key={cabang?.branch_code} value={cabang?.branch_code}>
                      {cabang?.branch_name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="module-form-group">
                <label className="module-form-label" htmlFor="calendar-school">
                  Sekolah <span>*</span>
                </label>
                <select
                  id="calendar-school"
                  name="ysb_school_id"
                  onChange={handleChange}
                  value={form.ysb_school_id}
                  className="module-form-select"
                  disabled={!form.ysb_branch_id || loadingSekolah}
                >
                  <option value="" disabled>
                    {!form.ysb_branch_id
                      ? "Pilih Cabang terlebih dahulu"
                      : loadingSekolah
                      ? "Memuat data..."
                      : "Pilih Sekolah"}
                  </option>
                  {getDataSekolah
                    .filter((school) => school.school_code !== "BASEMENT_BEKASI")
                    .map((school) => (
                      <option key={school?.school_code} value={school?.school_code}>
                        {school?.school_name}
                      </option>
                    ))}
                </select>
              </div>

              <div className="module-form-group">
                <label className="module-form-label" htmlFor="calendar-event-type">
                  Tipe Acara
                </label>
                <select
                  id="calendar-event-type"
                  name="ysb_event_id"
                  onChange={handleChange}
                  value={form.ysb_event_id}
                  className="module-form-select"
                  disabled={loadingEvent}
                >
                  <option value="">
                    {loadingEvent ? "Memuat data..." : "Pilih Tipe Acara"}
                  </option>
                  {getDataEvent.map((row) => (
                    <option key={row?.id} value={row?.id}>
                      {row?.name_event}
                    </option>
                  ))}
                </select>
              </div>

              <div className="module-form-group">
                <label className="module-form-label" htmlFor="calendar-date-in">
                  Tanggal Mulai <span>*</span>
                </label>
                <input
                  id="calendar-date-in"
                  className="module-form-input"
                  type="date"
                  name="date_in"
                  value={form.date_in}
                  onChange={handleChange}
                  onFocus={(e) => e.target.showPicker?.()}
                />
              </div>

              <div className="module-form-group">
                <label className="module-form-label" htmlFor="calendar-date-out">
                  Tanggal Akhir <span>*</span>
                </label>
                <input
                  id="calendar-date-out"
                  className="module-form-input"
                  type="date"
                  name="date_out"
                  value={form.date_out}
                  onChange={handleChange}
                  onFocus={(e) => e.target.showPicker?.()}
                  min={form.date_in || undefined}
                />
              </div>

              <div className="module-form-group module-form-span-2">
                <label className="module-form-label" htmlFor="calendar-title">
                  Judul <span>*</span>
                </label>
                <input
                  id="calendar-title"
                  className="module-form-input"
                  type="text"
                  name="title"
                  onChange={handleChange}
                  value={form.title}
                  
                />
              </div>

              <div className="module-form-group module-form-span-2">
                <label className="module-form-label" htmlFor="calendar-description">
                  Keterangan
                </label>
                <textarea
                  id="calendar-description"
                  className="module-form-textarea"
                  name="description"
                  value={form.description}
                  onChange={handleChange}
                  
                />
              </div>
            </div>
          </Modal.Body>

          <div className="module-modal-footer">
            <button
              type="button"
              className="module-modal-cancel"
              onClick={() => props.onHide?.()}
              disabled={isSubmitting}
            >
              Batal
            </button>

            <button
              className="module-modal-submit"
              type="submit"
              disabled={isSubmitting}
            >
              {isSubmitting && <span className="module-button-spinner" />}
              {isSubmitting
                ? "Menyimpan..."
                : isEdit
                ? "Simpan Perubahan"
                : "Tambahkan"}
            </button>
          </div>
        </Form>
      </Modal>
    </div>

  );
}